import { render, staticRenderFns } from "./BarSetting.vue?vue&type=template&id=65df43f9&"
import script from "./BarSetting.vue?vue&type=script&lang=js&"
export * from "./BarSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports